import { render, staticRenderFns } from "./mis-vacaciones.vue?vue&type=template&id=fb252806&scoped=true"
import script from "./mis-vacaciones.vue?vue&type=script&lang=js"
export * from "./mis-vacaciones.vue?vue&type=script&lang=js"
import style0 from "./mis-vacaciones.vue?vue&type=style&index=0&id=fb252806&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb252806",
  null
  
)

export default component.exports